import { ApolloCache, Reference } from "@apollo/client"
import { MATERIALTYPE_FRAGMENT } from "../fragment/materialType"

export const updateCacheMaterialType = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      materialTypes(existing = []) {
        const newMaterialTypeRef = cache.writeFragment({
          data: entryData,
          fragment: MATERIALTYPE_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newMaterialTypeRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newMaterialTypeRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newMaterialTypeRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newMaterialTypeRef
            }
            return items
        }
      },
      aggregateMaterialType(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
